import { Node } from '@tiptap/vue-3';

/**
 * Script tag node
 */
export const ScriptExtension = Node.create({
  name: 'script',
  group: 'block',
  content: 'text*',
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'script',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['script', HTMLAttributes, 0 ];
  },
});
